export enum PatronPreferences {
    PaperStatement = 'PaperStatement'
}